import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SeoService } from './service/seo.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'maTools';

  constructor(
    private router: Router,
    private seoService: SeoService
  ) {}

  ngOnInit(): void {
    // Set canonical URL for initial route
    const initialUrl = this.router.url || '/';
    this.updateSeoForRoute(initialUrl);
    
    // Listen to route changes and update SEO accordingly
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateSeoForRoute(event.url);
        // Scroll to top on navigation
        window.scrollTo(0, 0);
      });
  }

  private updateSeoForRoute(url: string): void {
    // Update canonical URL first to prevent duplicate content issues
    this.seoService.updateCanonicalUrl(url);
    
    // Extract route name from URL (handle root route)
    const pathParts = url.split('/').filter(part => part.length > 0);
    const routeName = pathParts.length > 0 ? pathParts[0] : '';
    
    // Get SEO data for the route (empty string for home)
    const seoData = this.seoService.getToolSeoData(routeName);
    
    // Update title and meta tags
    this.seoService.updateTitle(seoData.title);
    this.seoService.updateMetaDescription(seoData.description);
    this.seoService.updateMetaKeywords(seoData.keywords);
    
    // Update Open Graph tags
    this.seoService.updateOpenGraphTags(seoData.ogData);
    
    // Update Twitter Card tags
    this.seoService.updateTwitterCardTags(seoData.twitterData);
  }
}
